<template>
  <div>
    <!--筛选栏-->
    <div class="dateTab">
      <!--时间筛选-->
      <div class="yearList sepyear" style="border: 0px solid #ebebeb">
        <date-picker
          style="width: 114px; border: 1px solid rgb(235, 235, 235)"
          size="small"
          v-model="date_options"
          type="month"
          :picker-options="pickerOptions"
          clearable
        >
        </date-picker>
      </div>
      <!-- 派系筛选 -->
      <select-singles
        v-model="conditions.brand_origin"
        :width="80"
        text="派系"
        :options="options.origin_options"
        @reset="conditions_init('origin')"
        :key="'brand_origin' + component_key"
      />
      <!--车型级别-->
      <select-categories
        v-model="conditions.body_size"
        text="车型级别"
        :categories="options.body_size_options"
        @reset="conditions_init('body_size')"
        :key="'body_size' + component_key"
      />
      <!-- 动力形式筛选 -->
      <select-singles
        v-model="conditions.propulsion_type"
        :width="80"
        text="动力形式"
        :options="options.propulsion_options"
        @reset="conditions_init"
        :key="'propulsion_type' + component_key"
      />

      <!--按钮-->
      <div class="selectBut">
        <a @click="filter" href="javascript:;">查询</a>
        <a @click="reset" href="javascript:" class="clear">清空</a>
      </div>

      <!-- 面包屑 -->
      <bread-crumb
        v-model="breadcrumb_conditions"
        :options="options"
        @filter="filter"
        @deselect="deselect"
      />
    </div>
    <!--图表-->
    <div class="countChart" style="padding-bottom: 20px">
      <div class="charTitle">
        <chart-title :words="title_data" separator="_" />
        <div class="chartIcon"></div>
        <div class="tabListc">
          <ul ref="group">
            <li
              :class="
                conditions.query_type === 'localgroup' ||
                conditions.query_type === 'salesgroup'
                  ? 'tabLCur'
                  : ''
              "
              @click="group_display = !group_display"
            >
              <a href="javascript:;"
                ><em>{{ text.group }}</em></a
              >
              <transition name="gas-select">
                <p v-show="group_display">
                  <a @click="switch_project('localgroup', $event)" href="javascript:;"
                    >本土集团</a
                  >
                  <a @click="switch_project('salesgroup', $event)" href="javascript:;"
                    >销售集团</a
                  >
                </p>
              </transition>
            </li>
            <li
              @click="switch_project('manufacturer', $event)"
              :class="conditions.query_type === 'manufacturer' ? 'tabLCur' : ''"
            >
              <a href="javascript:;">车企</a>
            </li>
            <li
              @click="switch_project('brand', $event)"
              :class="conditions.query_type === 'brand' ? 'tabLCur' : ''"
            >
              <a href="javascript:;">品牌</a>
            </li>
            <li
              @click="switch_project('model', $event)"
              :class="conditions.query_type === 'model' ? 'tabLCur' : ''"
            >
              <a href="javascript:;">车系</a>
            </li>
            <li
              @click="switch_project('nameplate', $event)"
              :class="conditions.query_type === 'nameplate' ? 'tabLCur' : ''"
            >
              <a href="javascript:;">车型</a>
            </li>
          </ul>
        </div>
      </div>

      <bars
        :volume_data="volume_data"
        :series_name="text.data_type"
        styles="width:960px;height:418px;"
        :year="date_options.getFullYear()"
        :month="date_options.getMonth() + 1"
        :is_loading="is_chart_loading"
      />
    </div>
    <!--表格-->
    <div class="detailData">
      <div class="charTitle">
        <div class="title">所选详细数据</div>
        <download
          url="/excel/rank"
          :params="{
            type: conditions.data_type,
            year: date_options.getFullYear(),
            month: date_options.getMonth() + 1,
            bodyType: JSON.stringify(conditions.body_size),
            propulsionTypeId: conditions.propulsion_type.join(','),
            brandOriginId: conditions.brand_origin.join(','),
            queryType: conditions.query_type,
            previousMonth: conditions.previous_month,
          }"
          :words="title_data"
          separator="_"
        />

        <div class="tabListc">
          <ul>
            <li :class="conditions.previous_month === 3 ? 'tabLCur' : ''">
              <a @click="switch_month(3)" href="javascript:;">近3个月</a>
            </li>
            <li :class="conditions.previous_month === 6 ? 'tabLCur' : ''">
              <a @click="switch_month(6)" href="javascript:;">近6个月</a>
            </li>
            <li :class="conditions.previous_month === 9 ? 'tabLCur' : ''">
              <a @click="switch_month(9)" href="javascript:;">近9个月</a>
            </li>
            <li :class="conditions.previous_month === 12 ? 'tabLCur' : ''">
              <a @click="switch_month(12)" href="javascript:;">近12个月</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="detailshow">
        <div class="dtDLeft onelineLeft">
          <div class="dataForm" :style="is_loading ? 'height:416px;' : ''">
            <transition name="loading">
              <loading v-show="is_loading" />
            </transition>
            <transition name="loading">
              <table
                cellpadding="0"
                cellspacing="0"
                border="0"
                width="100%"
                v-show="!is_loading"
              >
                <tbody>
                  <tr>
                    <th>排序</th>
                    <th>{{ text.query_type }}</th>
                    <th v-if="conditions.query_type === `manufacturer`">品牌</th>
                    <th>{{ text.query_time }}</th>
                    <th>月环比</th>
                    <th>月同比</th>
                    <th>月累计同比</th>
                    <th v-for="(time, index) in table_data.times" :key="index">
                      {{ time }}
                    </th>
                  </tr>
                  <tr v-for="(item, index) in table_data.result" :key="index">
                    <td>{{ item.rowNumber }}</td>
                    <td>{{ item.project }}</td>
                    <td v-if="conditions.query_type === `manufacturer`">
                      {{ item.affix }}
                    </td>
                    <td>{{ item.volume | num_format }}</td>
                    <td>{{ item.moM }}</td>
                    <td>{{ item.yoY }}</td>
                    <td>{{ item.cyoy }}</td>
                    <td v-for="(volume, index) in item.volumes" :key="index">
                      {{ volume | num_format }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </transition>
          </div>
        </div>
        <!--dtDLeft-->
        <div class="dtDRight onelineRight">
          <div class="dateEdit doubleTitle"></div>
          <!--dateEdit-->
        </div>
        <!--dtDRight-->
      </div>
      <!-- detailshow-->

      <pagination
        :page="page"
        @pagehandler="pageHandler"
        v-show="page.total > page.size"
      />
    </div>
    <!--提示-->
    <tips />
  </div>
</template>

<script>
import SelectSingles from "@/components/select/select-singles";
import SelectCategories from "@/components/select/select-categories";
import BreadCrumb from "@/components/breadcrumb";
import { DatePicker } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Tips from "@/components/tips";
import Loading from "@/components/loading";
import Pagination from "@/components/pagination";
import Download from "@/components/download";
import Bars from "@/components/echarts/bars-charts";
import ChartTitle from "@/components/chart-title";

export default {
  name: "rank",
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        {
          name: "keywords",
          content: this.meta.keywords,
        },
        {
          name: "description",
          content: this.meta.description,
        },
      ],
    };
  },
  components: {
    SelectSingles,
    SelectCategories,
    BreadCrumb,
    DatePicker,
    Tips,
    Loading,
    Pagination,
    Download,
    Bars,
    ChartTitle,
  },
  data() {
    return {
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
      date_options: new Date(),
      options: {
        origin_options: [],
        body_size_options: [],
        propulsion_options: [],
      },
      breadcrumb_conditions: {},
      conditions: {
        data_type: "production",
        query_type: "manufacturer",
        previous_month: 3,
        body_size: [],
        propulsion_type: [],
        brand_origin: [],
      },
      volume_data: [],
      table_data: [],
      title_data: [],
      page: {
        index: 1,
        size: 10,
        temp_index: 1,
        total: 0,
      },
      text: {
        data_type: "",
        group: "集团",
        query_type: "车企",
        temp_query_type: "车企",
        query_time: "",
      },
      pickerOptions: {
        disabledDate: function (time) {
          var startdate = new Date("2015-12-31").getTime();
          var enddate = new Date("2028-12-31").getTime();
          return !(time.getTime() > startdate && time.getTime() < enddate);
        },
      },
      is_loading: true,
      is_chart_loading: true,
      group_display: false,
      component_key: 0,
    };
  },
  watch: {
    $route(new_val) {
      this.date_options = this.$store.state.time_node;
      this.is_loading = true;
      this.is_chart_loading = true;
      this.conditions.data_type = new_val.params.data_type;
      if (this.conditions.data_type === "production") {
        this.text.data_type = "产量";
        this.meta.title = "汽车产量排行榜数据查询-盖亚系统";
        this.meta.keywords = "汽车产量排行榜数据";
        this.meta.description =
          "汽车产量排行榜数据：可根据年份、派系、车型级别、动力形式等查询条件查询到对应汽车产量排行榜数据。";
      } else {
        this.text.data_type = "销量";
        this.meta.title = "汽车销量排行榜数据查询-盖亚系统";
        this.meta.keywords = "汽车销量排行榜";
        this.meta.description =
          "汽车销量排行榜数据：可根据年份、派系、车型级别、动力形式等查询条件查询到对应汽车销量排行榜数据。";
      }
      this.filter();
    },
  },
  mounted() {
    this.date_options = this.$store.state.time_node;
    this.conditions.data_type = this.$route.params.data_type;
    if (this.conditions.data_type === "production") {
      this.text.data_type = "产量";
      this.meta.title = "汽车产量排行榜数据查询-盖亚系统";
      this.meta.keywords = "汽车产量排行榜数据";
      this.meta.description =
        "汽车产量排行榜数据：可根据年份、派系、车型级别、动力形式等查询条件查询到对应汽车产量排行榜数据。";
    } else {
      this.text.data_type = "销量";
      this.meta.title = "汽车销量排行榜数据查询-盖亚系统";
      this.meta.keywords = "汽车销量排行榜";
      this.meta.description =
        "汽车销量排行榜数据：可根据年份、派系、车型级别、动力形式等查询条件查询到对应汽车销量排行榜数据。";
    }
    this.conditions_init();

    document.addEventListener("click", (e) => {
      if (this.$refs.group) {
        if (!this.$refs.group.contains(e.target)) {
          this.group_display = false;
        }
      }
    });
  },
  methods: {
    conditions_init(option) {
      let _this = this;
      switch (option) {
        case "origin":
          _this.conditions.body_size.body_type = 0;
          _this.conditions.body_size.global_size = 0;
          break;
        case "bodysize":
          _this.conditions.propulsion_type = 0;
          break;
      }
      this.$http({
        url: "/rank/condition",
        method: "get",
        crossdomain: true,
        params: {
          brandOriginId: _this.conditions.brand_origin,
          bodyTypeId: _this.conditions.body_size.body_type,
          globalSizeId: _this.conditions.body_size.global_size,
          propulsionTypeId: _this.conditions.propulsion_type,
        },
      })
        .then(function (res) {
          _this.options.origin_options = res.data.brandOrigins;
          _this.options.body_size_options = res.data.bodyTypes;
          _this.options.propulsion_options = res.data.propulsionTypes;
          _this.filter();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reset() {
      this.is_loading = true;
      this.is_chart_loading = true;
      this.conditions.body_size = this.conditions.propulsion_type = this.conditions.brand_origin = [];
      this.conditions_init();
      this.component_key += 1;
    },
    filter() {
      let _this = this;
      this.$http({
        url: "/rank/filter",
        method: "get",
        crossdomain: true,
        params: {
          type: _this.conditions.data_type,
          year: _this.date_options.getFullYear(),
          month: _this.date_options.getMonth() + 1,
          bodyType: JSON.stringify(_this.conditions.body_size),
          propulsionTypeId: _this.conditions.propulsion_type.join(","),
          brandOriginId: _this.conditions.brand_origin.join(","),
          queryType: _this.conditions.query_type,
        },
      })
        .then(function (res) {
          _this.volume_data = res.data;
          _this.breadcrumb_conditions = JSON.parse(JSON.stringify(_this.conditions));
          _this.text.query_type = _this.text.temp_query_type;
          _this.text.query_time =
            _this.date_options.getFullYear() + "-" + (_this.date_options.getMonth() + 1);

          _this.title();
          _this.is_chart_loading = false;
        })
        .catch(function (error) {
          if (error.response == undefined) {
            return false;
          }
          switch (error.response.status) {
            case 403:
              _this.date_options = _this.$store.state.time_node;
              break;
          }
        });
      this.filter_table();
    },
    filter_table() {
      let _this = this;
      this.$http({
        url: "/rank/filtertable",
        method: "get",
        crossdomain: true,
        params: {
          type: _this.conditions.data_type,
          year: _this.date_options.getFullYear(),
          month: _this.date_options.getMonth() + 1,
          bodyType: JSON.stringify(_this.conditions.body_size),
          propulsionTypeId: _this.conditions.propulsion_type.join(","),
          brandOriginId: _this.conditions.brand_origin.join(","),
          queryType: _this.conditions.query_type,
          previousMonth: _this.conditions.previous_month,
          pageIndex: _this.page.temp_index,
          pageSize: _this.page.size,
        },
      })
        .then(function (res) {
          _this.table_data = res.data;
          _this.page.total = res.data.allCount;
          _this.page.index = _this.page.temp_index;
          _this.is_loading = false;
          _this.is_chart_loading = false;
        })
        .catch(function (error) {
          if (error.response == undefined) {
            return false;
          }
          switch (error.response.status) {
            case 403:
              _this.date_options = _this.$store.state.time_node;
              break;
          }
        });
    },
    switch_month(month) {
      this.is_loading = true;
      this.conditions.previous_month = month;
      this.page.temp_index = 1;
      this.filter_table();
    },
    switch_project(query_type, e) {
      this.text.temp_query_type = e.srcElement.innerText;
      this.is_loading = true;
      this.is_chart_loading = true;
      this.conditions.query_type = query_type;
      switch (this.conditions.query_type) {
        case "localgroup":
          this.text.group = "本土集团";
          break;
        case "salesgroup":
          this.text.group = "销售集团";
          break;
        default:
          this.text.group = "集团";
      }
      this.filter();
    },
    title() {
      let _this = this;
      this.title_data = [];
      this.title_data.push(
        _this.date_options.getFullYear() + "-" + (_this.date_options.getMonth() + 1)
      );
      // this.title_data.push(_this.conditions.brand_origin !== 0 ? _this.options.origin_options.filter(t => t.brandOriginId === _this.conditions.brand_origin)[0].brandOriginName : '');
      // if(_this.conditions.body_size.body_type !== 0 && _this.conditions.body_size.global_size !== 0)
      // {
      //   let global_sizes = _this.options.body_size_options.filter(t => t.bodyTypeId === _this.conditions.body_size.body_type)[0].globalSizes
      //   this.title_data.push(_this.conditions.body_size.global_size !== 0 ? global_sizes.filter(t => t.globalSizeId === _this.conditions.body_size.global_size)[0].globalSizeName : '');
      //   this.title_data.push(_this.conditions.body_size.body_type !== 0 ? _this.options.body_size_options.filter(t => t.bodyTypeId === _this.conditions.body_size.body_type)[0].bodyTypeName : '');
      // }
      // this.title_data.push(_this.conditions.propulsion_type !== 0 ? _this.options.propulsion_options.filter(t => t.propulsionTypeId === _this.conditions.propulsion_type)[0].propulsionTypeName : '');
      this.title_data.push(
        "所选条件下" +
          this.text.query_type +
          (_this.conditions.data_type === "production" ? "产量" : "销量") +
          "排行榜"
      );
    },
    pageHandler: function (page) {
      this.page.temp_index = page;
      this.filter_table();
    },
    deselect(condition_type, choiced_value, attach) {
      switch (condition_type) {
        case "brand_origin":
          this.conditions.brand_origin.splice(
            this.conditions.brand_origin.indexOf(choiced_value),
            1
          );
          break;
        case "propulsion_type":
          this.conditions.propulsion_type.splice(
            this.conditions.propulsion_type.indexOf(choiced_value),
            1
          );
          break;
        case "body_size":
          this.conditions.body_size.splice(
            this.conditions.body_size.indexOf(
              this.conditions.body_size.find((t) => t.body_type === choiced_value)
            ),
            1
          );
          break;
        case "global_size":
          if (
            this.conditions.body_size.find((t) => t.body_type === choiced_value)
              .global_size.length === 1
          ) {
            this.conditions.body_size.splice(
              this.conditions.body_size.indexOf(
                this.conditions.body_size.find((t) => t.body_type === choiced_value)
              ),
              1
            );
          } else {
            this.conditions.body_size
              .find((t) => t.body_type === choiced_value)
              .global_size.splice(
                this.conditions.body_size
                  .find((t) => t.body_type === choiced_value)
                  .global_size.indexOf(attach),
                1
              );
          }
          break;
      }
    },
  },
};
</script>
